import { ProductTypeConfig, DEFAULT_SECTIONS } from '../types';

/**
 * 2200 - Knock Out Warrant
 */
export const config2200: ProductTypeConfig = {
  code: '2200',
  name: 'Knock Out Warrant',
  sections: {
    ...DEFAULT_SECTIONS,
    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false,
        premium: true,
        quotationType: true,
        strike: true,
        basketOptionType: true,
        settlementType: true,
        barrierType: true,
        lowerBarrier: true,
        upperBarrier: true,
      },
    },
    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
    },
    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      enabled: true,
    },
  },
};
